
import React from 'react';
import './ChatRooms.css';
import ChatHistory from '../components/chat/ChatHistory';

import { useState, useEffect } from "react";
import { auth, firestore } from '../Firebase';
import { collection, getDocs, updateDoc, doc, addDoc, query, orderBy } from "firebase/firestore";
import { useCollectionData } from 'react-firebase-hooks/firestore';

import { useAuth, UserAuth} from '../components/AuthContext.js'

import { 
    Box,
    Input,
    Button,
    Text
 } from '@chakra-ui/react'

//import { passwordValidate } from '../utils/form-validate';

function ChatRoomsPage() {

    const [chatsDisplay, setChatsDisplay] = useState([]);
    const [chatID, setChatID] = useState(Number(0));
    const { user, logOut } = UserAuth();
    const chatsRef = collection(firestore, "chats")
    const q = query(chatsRef)
    const [chats] = useCollectionData(q, {id: 'id'})

    var messagesRef = collection(firestore, "/chats/" + chatID + "/messages")
    const q1 = query(messagesRef, orderBy("date", "asc"))
    const [messages] = useCollectionData(q1, {id: 'id'})

    const [messageText, setMessageText] = useState("");
    console.log(messageText);
    const auth = useAuth();
    const [openDialog, setOpenDialog] = useState(false);
   
    useEffect(() => {
        setChatID(Number(0))
        
    }, [])
    
    
    const sendMessage = async () => {
        messagesRef = collection(firestore, "/chats/" + chatID + "/messages")
        console.log("loading2");
        await addDoc(messagesRef, {sender: auth.user.name, text: messageText, date: Number(Date.now())});
        console.log(messageText);
        document.getElementById("message-buffer").value = ""
    };

    const selectChat = async (id) => {
        setChatID(id);
        
        const chatDoc = doc(firestore, "chats", id)
        const newFields = {isNewChat: false}
        await updateDoc(chatDoc, newFields)

    }


    return(
        <>
        {/* <div style={{ 
            backgroundImage: "./Foodsurf.png", height:"100%", width:"100%", alt:"truck and logo"}}> */}
        <div className='everything'>   
            <img height="100%" width="100%" src="./rainbowbg.jpeg" alt="truck and logo" />

        <div className="splitScreen">

            <div className="leftPane">
                <ChatHistory
                    chats={chats}
                    selectChat={selectChat} />
            </div>

            <div className="rightPane">

                {/* if chatID is zero (default), then we tell the user to select a chat
otherwise, display the associated messages with the current chat's id */}
                {chatID == Number(0) ? (
                        <Text mt="20%" mR="20%" fontSize={32}  color="black">Select a chat to get started!</Text>


                ) : (
                    <Box overflowY='scroll' mt="24" ml="-8" mr="8" height="55vh" maxW="auto" p="4" borderWidth="1px" borderRadius="sm">

                        {messages?.map(message => <Box mY="5px" ml="1" mr="4" maxW="md" pY="0" borderWidth="1px" borderRadius="md" borderColor="purple">
                            <Text color="black" textAlign="left" fontSize={22}>{message.sender}: {message.text}</Text></Box>
                        )}
                    </Box>


                )}


                {chatID == Number(0) ? (null) : (
                    <><Input mr="8" mt="12" ml="-8" size='md' width="60%" p="15" colorScheme="purple" borderWidth="1px"
                        borderRadius="md" borderColor="purple" disabled={chatID == 0} id="message-buffer" type="text"
                        placeholder="Message"         
                        onChange={(event) => {
            setMessageText(event.target.value);
        }}
/>
                        <Button mb="8" pY="1" size='md' width="15%" type="submit" bg="#D60270" loadingText="Send"
                            onClick={() => { sendMessage(messageText); } } >
                            <Text fontSize="md" pY="0" color="white">Send</Text>
                        </Button></>)}

            </div>
        </div></div> </>
            
        );
    }
    
    export default ChatRoomsPage;